import React from 'react';
import LinkGrid from 'shared/components/data-display/LinkGrid';
import { CardControls, CardSection } from 'shared/components/cardControls';
import { tenantRadiusSearchPath } from 'shared/routes/networking';

/**
 * @param {Object} props
 * @param {Object} props.tenantState - Tenant state object
 */
export default function TenantNetworkingLinks({ tenantState }) {
  const descriptions = [];

  if (tenantState.canAccessNetworking) {
    descriptions.push({
      title: 'Networking',
      links: [{
        link: `${tenantRadiusSearchPath}?tenant_id=${tenantState.data.id}`,
        text: 'Tenant Radius Records',
      }],
    });
  }

  return (
    <CardSection>
      <CardControls editEnabled={false} />
      <LinkGrid descriptions={descriptions} />
    </CardSection>
  );
}
